<template lang="pug">
	.organization-details(v-if="data" )
		h3.organization-details__title {{ data.worktime.title }}

		.organization-details__worktime
			.organization-details__worktime-item(
				v-for="(item, index) in data.worktime.items"
				:key="index"
			)
				span.organization-details__worktime-title {{ item.title }}
				span.organization-details__worktime-value {{ item.value }}
		.organization-details__announcement(v-html="data.worktime.announcement")

		h3.organization-details__goverment-title {{ data.worktime.governmentTitle }}
		span.organization-details__goverment-value(v-html="data.worktime.governmentText")
</template>

<script>
import sourceMixin from "./mixins/v-mixin-source.vue";
import isMobMixin from "./mixins/v-mixin-is-mob.vue";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}
</script>